var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs6":"","sm1":"","md1":""}},[_c('div',{staticClass:"caption grey--text"},[_vm._v(" Ratio ")]),_c('div',[_vm._v(_vm._s(_vm.torrent.ratio))])])}
var staticRenderFns = []

export { render, staticRenderFns }